var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedBack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 11,
    viewBox: "0 0 8 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.16218 6.01251C0.738605 5.61718 0.738604 4.94574 1.16218 4.5504L5.39659 0.598287C6.03581 0.00168133 7.07891 0.454962 7.07891 1.32934L7.07891 9.23357C7.07891 10.1079 6.03581 10.5612 5.39659 9.96463L1.16218 6.01251Z",
    fill: "#B82323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedBack);
export default __webpack_public_path__ + "static/media/redBack.7b6ce268682c4424a02dea5965c4962c.svg";
export { ForwardRef as ReactComponent };